<div class="grade-bar">
    <div class="grade-bar__specs">
        <span class="grade-bar__spec">{{ getMinValue | number:'1.2-2' }}</span>
        <span class="grade-bar__spec">{{ getMaxValue | number:'1.2-2' }}</span>
    </div>

    <div class="grade-bar__track">
        <div *ngIf="getMinValue > 0 && getLeftCriticalAreaWidth > 0"
             class="grade-bar__area grade-bar__area--critical"
             [style.width.%]="getLeftCriticalAreaWidth"></div>
        <div *ngIf="getMinValue > 0 && getLeftErrorAreaWidth > 0"
             class="grade-bar__area grade-bar__area--error"
             [style.width.%]="getLeftErrorAreaWidth"></div>
        <div class="grade-bar__area grade-bar__area--safe">
            <div class="grade-bar__marker"
                 [class.grade-bar__marker--warning]="markerState === 'warning'"
                 [class.grade-bar__marker--critical]="markerState === 'critical'"
                 [style.left.%]="getMarkerPosition"></div>
        </div>
        <div *ngIf="getMaxValue > 0 && getRightErrorAreaWidth > 0"
             class="grade-bar__area grade-bar__area--error"
             [style.width.%]="getRightErrorAreaWidth"></div>
        <div *ngIf="getMaxValue > 0 && getRightCriticalAreaWidth > 0"
             class="grade-bar__area grade-bar__area--critical"
             [style.width.%]="getRightCriticalAreaWidth"></div>
    </div>
</div>